import React from 'react';

import { useAppDispatch } from '../../store/hooks';
import { fetchMatchingEventViews } from '../../store/thunks';

/**
 * Loads matching projections for a list of events with ONE batch request, after the list is known.
 * Re-runs only when the set of event ids changes.
 */
export function useMatchingEventViews(eventIds: string[]): void {
  const dispatch = useAppDispatch();
  const key = React.useMemo(() => [...new Set(eventIds)].sort().join(','), [eventIds]);

  React.useEffect(() => {
    if (!key) return;
    void dispatch(fetchMatchingEventViews({ eventIds: key.split(',') }));
  }, [dispatch, key]);
}
